/**
 *  A helper function to check if Sentry is enabled and we should send errors to it.
 */
export function isSentryEnabled() {
  // Do we have the Sentry DSN?
  return (
    import.meta.env.VITE_SENTRY_FRONTEND_DSN &&
    // is the config telling us to not disable Sentry?
    import.meta.env.VITE_DISABLE_SENTRY !== "true" &&
    // are we not in a test environment?
    typeof window !== "undefined"
  )
}
